import { render, staticRenderFns } from "./MedicalExaminationPreviewModal.vue?vue&type=template&id=2fdcbc62&"
import script from "./MedicalExaminationPreviewModal.vue?vue&type=script&lang=js&"
export * from "./MedicalExaminationPreviewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports